export default __webpack_public_path__ + "static/media/font3.92352a0b.svg";